interface IconProps extends React.SVGProps<SVGSVGElement> {}

export const StarMiniIcon: React.FC<IconProps> = (props) => {
    return (
        <svg id="icoStarMini" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" {...props}>
            <rect id="Rectangle_5326" width="24" height="24" fill="none" />
            <path
                id="Path_7171"
                d="M12.056,4.657a1.048,1.048,0,0,0,.817.586l4.519.555a1.05,1.05,0,0,1,.582,1.818l-3.288,3.012a1.048,1.048,0,0,0-.323.974l.852,4.35a1.05,1.05,0,0,1-1.527,1.126l-4.037-2.17a1.052,1.052,0,0,0-.995,0l-4.04,2.173a1.05,1.05,0,0,1-1.527-1.126l.852-4.35a1.051,1.051,0,0,0-.321-.977L.341,7.617A1.05,1.05,0,0,1,.921,5.8l4.52-.555a1.048,1.048,0,0,0,.817-.587L8.208.6A1.05,1.05,0,0,1,10.1.6Z"
                transform="translate(2.842 2.85)"
                fill="#ff7804"
            />
        </svg>
    );
};
